<div class="flex-fill d-flex dx-card">
  @if (!showAsComponent) {
    <div class="d-flex flex-fill flex-column col-sm-6">
      <div class="d-flex flex-column flex-fill p-3">
        <h4>Payments</h4>
        <dx-data-grid
          #paymentsGrid
          [keyExpr]="'id'"
          class="flex-fill d-flex flex-column"
          height="100px"
          [dataSource]="payments"
          [showBorders]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onRowDblClick)="onPaymentDoubleClick($event)"
          [columnAutoWidth]="true"
          >
          <dxi-data-grid-column dataField="id" width="75"></dxi-data-grid-column>
          <dxi-data-grid-column
            dataField="customer.companyName"
            caption="Customer"
            width="150"
            cellTemplate="customerLinkTemplate"
          ></dxi-data-grid-column>
          <dxi-data-grid-column dataField="paymentDate" caption="Date" width="75"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="paymentMethod.name" caption="Method" width="75"></dxi-data-grid-column>
          <dxi-data-grid-column
            dataField="paymentAmount"
            caption="Amount"
            [format]="{ type: 'currency', precision: 2 }"
            width="75"
          ></dxi-data-grid-column>
          <dxi-data-grid-column dataField="referenceNumber" caption="Ref#" width="75"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="quickBooksId" caption="QB ID" width="75"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="quickBooksExport" caption="QB Export" width="75"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="created" dataType="date" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="createdBy" width="100"></dxi-data-grid-column>
          <div *dxTemplate="let cell of 'customerLinkTemplate'">
            @if (cell && isPaymentAdmin) {
              <a [routerLink]="'/customers/' + cell.data.customerId" [innerHtml]="cell.text"></a>
            }
            @if (cell && !isPaymentAdmin) {
              <div [innerHtml]="cell.text"></div>
            }
          </div>
          <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
          <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
          <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
          <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
          <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="payments-grid"></dxo-data-grid-state-storing>
          <div *dxTemplate="let data of 'toolbarButtons'">
            <button
              class="btn btn-primary me-1 mb-2"
              (click)="openPayment(paymentsGrid.instance.getSelectedRowsData()[0]?.id)"
              [disabled]="paymentsGrid.instance.getSelectedRowsData().length !== 1"
              [hidden]="!isPaymentAdmin"
              >
              Open
            </button>
            <button
              class="btn btn-danger me-3 mb-2"
              (click)="delete(paymentsGrid.instance.getSelectedRowsData()[0])"
              [disabled]="paymentsGrid.instance.getSelectedRowsData().length !== 1"
              [hidden]="!isPaymentAdmin"
              >
              Delete
            </button>
            <button
              class="btn btn-secondary me-1 mb-2"
              (click)="payWithoutQuickBooks(paymentsGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="
                            paymentsGrid.instance.getSelectedRowsData().length !== 1 ||
                            paymentsGrid.instance.getSelectedRowsData()[0].quickBooksId ||
                            paymentsGrid.instance.getSelectedRowsData()[0].quickBooksExport
                        "
              [hidden]="!isPaymentAdmin"
              >
              Pay w/o QuickBooks
            </button>
            <button
              class="btn btn-secondary me-1 mb-2"
              (click)="printPaymentReceipt(paymentsGrid.instance.getSelectedRowsData())"
              [disabled]="paymentsGrid.instance.getSelectedRowsData().length === 0"
              [hidden]="!isPaymentAdmin"
              >
              Print
            </button>
            <button
              class="btn btn-secondary mb-2"
              (click)="emailPaymentReceipt(paymentsGrid.instance.getSelectedRowsData()[0])"
              [disabled]="paymentsGrid.instance.getSelectedRowsData().length !== 1"
              [hidden]="!isPaymentAdmin"
              >
              Email
            </button>
          </div>
          <div *dxTemplate="let data of 'toolbarText'">
            @if (payments) {
              <span class="me-3">
                <strong>{{ paymentsGrid.instance.totalCount() + ' items' }}</strong>
              </span>
            }
          </div>
        </dx-data-grid>
      </div>
    </div>
  }
  <div [class]="(showAsComponent ? '' : '') + ' d-flex flex-column flex-fill p-2  col-sm-6'">
    @if (!showAsComponent) {
      <h4>Open Invoices</h4>
    }
    <div class="d-flex flex-column flex-fill p-1">
      <dx-data-grid
        #overviewGrid
        keyExpr="id"
        class="flex-fill d-flex flex-column"
        height="100px"
        [dataSource]="invoices"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onRowDblClick)="onRowDoubleClick($event)"
        [columnAutoWidth]="false"
        >
        <dxi-data-grid-column dataField="id" caption="Id" width="75" cellTemplate="invoiceLinkTemplate"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="invoiceNumber" caption="Invoice #" width="75" cellTemplate="invoiceLinkTemplate"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="rentalIdDisplay" caption="Rental" width="75" cellTemplate="rentalLinkTemplate"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="status.name" caption="Status" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="total" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column
          dataField="customer.displayName"
          caption="Customer"
          width="175"
          cellTemplate="customerLinkTemplate"
        ></dxi-data-grid-column>
        <dxi-data-grid-column dataField="displayBillAddress" caption="Billing Address"></dxi-data-grid-column>

        <div *dxTemplate="let cell of 'invoiceLinkTemplate'">
          @if (cell && isPaymentAdmin) {
            <a [routerLink]="'/invoices/' + cell.data.id" [innerHtml]="cell.text"></a>
          }
          @if (cell && !isPaymentAdmin) {
            <div [innerHtml]="cell.text"></div>
          }
        </div>

        <div *dxTemplate="let cell of 'rentalLinkTemplate'">
          @if (cell && isPaymentAdmin) {
            <a [routerLink]="'/rentals/' + cell.data.rentalId" [innerHtml]="cell.text"></a>
          }
          @if (cell && !isPaymentAdmin) {
            <div [innerHtml]="cell.text"></div>
          }
        </div>

        <div *dxTemplate="let cell of 'customerLinkTemplate'">
          @if (cell && isPaymentAdmin) {
            <a [routerLink]="'/customers/' + cell.data.customerId" [innerHtml]="cell.text"></a>
          }
          @if (cell && !isPaymentAdmin) {
            <div [innerHtml]="cell.text"></div>
          }
        </div>

        <div *dxTemplate="let data of 'toolbarButtons'">
          @if (!showAsComponent) {
            <span>
              <button
                class="btn btn-success me-1 mb-2"
                (click)="receivePayment()"
                [disabled]="overviewGrid.instance.getSelectedRowsData().length === 0"
                [hidden]="!isPaymentAdmin"
                >
                Receive Payment
              </button>
            </span>
          }
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (invoices) {
            <span class="me-3">
              <strong>{{ overviewGrid.instance.totalCount() + ' items' }}</strong>
            </span>
          }
        </div>

        <dxo-data-grid-selection [mode]="'single'"></dxo-data-grid-selection>
        <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
        <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="payment-invoice-overview-grid"></dxo-data-grid-state-storing>
      </dx-data-grid>
    </div>
  </div>
</div>
